import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPreviewPopupShareTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PREVIEW_POPUP_SHARE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_SHARE_REPORT;

	get id(): string {
		return TourId.REPORTS__PREVIEW_POPUP_SHARE;
	}

	override get keyForPersistantDone(): string {
		return ReportsPreviewPopupShareTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					return $('.popup-type-board-preview .title .actions-right .share-link');
				},
			},
		];
	}
}
